import { GetStartedButton } from 'component-library/components/buttons/GetStartedButton';
import { LogInButton } from 'component-library/components/buttons/LogInButton';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import { device } from 'component-library/styles/device';
import React, { FC } from 'react';
import styled from 'styled-components';

import { NavigationProps } from '../Navigation';
import { baseNavWrapperStyles, MENU_ITEMS } from '../shared';
import { DesktopNavigationRetirableLogo } from './DesktopNavigationRetirableLogo';
import { Services } from './Services';

export const Header = styled(ShowOn)`
  height: 89px;
  ${baseNavWrapperStyles}

  padding: 16px 20px;

  ${`@media ${device.xl}`} {
    padding: 16px 40px;
  }
`;

const Menu = styled.div`
  display: flex;
  flex: auto;
  justify-content: space-between;
  max-width: 605px;
  margin: 0 32px;
`;

export const InnerWrapper = styled(Flex)`
  max-width: 1648px;
  margin: auto;
  height: 100%;
`;

export const DesktopNav: FC<NavigationProps> = ({ simpleNav = false, onPrimaryCtaClick }) => (
  <Header screens={[Screen.Lg, Screen.Xl, Screen.Xxl]}>
    <InnerWrapper alignItems="center" justifyContent="space-between">
      <DesktopNavigationRetirableLogo />
      {!simpleNav && (
        <>
          <Menu>
            <Services />
            {MENU_ITEMS.map(({ label, to }, idx) => (
              <LinkWrapper to={to} key={idx}>
                <ResponsiveBody variant={3} medium>
                  {label}
                </ResponsiveBody>
              </LinkWrapper>
            ))}
          </Menu>
          <Flex>
            <ShowOn screens={[Screen.Xl, Screen.Xxl]}>
              <LogInButton small marginRight={16} />
            </ShowOn>
            <GetStartedButton small withCaret={false} onClick={onPrimaryCtaClick} />
          </Flex>
        </>
      )}
    </InnerWrapper>
  </Header>
);
